import useExternalAutomation from 'data/firestore/agent/externalautomation/use';
import Calendar from 'components/icons/calendar';
import Note from 'components/icons/note';
import Social from 'components/icons/social';
import { getFormatter } from 'data/services/date/formatter';
import { Externalautomation } from 'data/firestore/agent/externalautomation/types';
import DetailElement from './detail';
import {
    Container,
    DetailsElements,
    Footer,
    Gradient,
} from './styled';
import ExternalAutomationInfo from './info';

const dateFormatter = getFormatter('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'utc',
});

interface ExternalAutomationProfileProps {
    agentId?: string;
    externalautomationId?: string;
    footer?: React.ReactNode;
}

const platformsMap: Record<Externalautomation['platform'], string> = {
    make: 'Make.com',
};

const ExternalAutomationProfile = ({
    agentId = '',
    externalautomationId = '',
    footer,
}: ExternalAutomationProfileProps) => {
    const { data: externalautomationData, isLoading } = useExternalAutomation(
        agentId,
        externalautomationId,
        {
            disabled: !agentId || !externalautomationId,
        },
    );

    return (
        <Container>
            <ExternalAutomationInfo
                externalautomation={externalautomationData}
            />
            <div className="rainbow-flex rainbow-flex_column">
                <DetailsElements>
                    <DetailElement
                        icon={<Note />}
                        label="Description"
                        value={externalautomationData?.description || ''}
                        isLoading={isLoading}
                    />
                    <DetailElement
                        icon={<Social />}
                        label="Platform"
                        value={externalautomationData ? platformsMap[externalautomationData.platform] : ''}
                        isLoading={isLoading}
                    />
                    <DetailElement
                        icon={<Calendar />}
                        label="Created At"
                        value={
                            externalautomationData?.createdAt
                            && dateFormatter.format(new Date(externalautomationData.createdAt))
                        }
                        isLoading={isLoading}
                    />
                </DetailsElements>
            </div>
            <Gradient />
            <Footer>
                {footer}
            </Footer>
        </Container>
    );
};

export default ExternalAutomationProfile;
